import React, { useState } from 'react'
import {
  ActionBar,
  ActionBarMessage,
  ActionBarActions,
} from '@lightspeed/design-system-react'
import { T, UT } from '@transifex/react'
import { RecordMovementButton } from './actions/RecordMovementButton'
import { RecordMovementModal } from './actions/RecordMovementModal'
import { MovementVariant, Movement } from './utils/types'

interface Props {
  onRecordMovementSuccess: (cashMovement: Movement) => void
}

const actionBarMessage = (
  <ActionBarMessage>
    <T _str="Record your cash movements for the day." />{' '}
    <UT
      _str={
        '<a class="vd-link vd-link--secondary vd-no-wrap" target="_blank" data-track="cash-management-action-bar-need-help" href="https://support.vendhq.com/hc/en-us/articles/207884598" >Need help? <i class="fa fa-external-link vd-ml1 vd-icon" /></>'
      }
      _inline
    />
  </ActionBarMessage>
)

export const CashManageActionBar: React.FC<Props> = ({
  onRecordMovementSuccess,
}) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false)
  const [modalVariant, setModalVariant] = useState<MovementVariant>(
    MovementVariant.Add
  )

  const handleRecordMovementButtonClick = (variant: MovementVariant) => {
    setModalVariant(variant)
    setModalOpen(true)
  }

  return (
    <>
      <ActionBar variant="page">
        {actionBarMessage}
        <ActionBarActions>
          <RecordMovementButton
            variant={MovementVariant.Remove}
            onClick={handleRecordMovementButtonClick}
          />
          <RecordMovementButton
            variant={MovementVariant.Add}
            onClick={handleRecordMovementButtonClick}
          />
        </ActionBarActions>
      </ActionBar>
      {isModalOpen && (
        <RecordMovementModal
          onClose={() => setModalOpen(false)}
          onSuccess={onRecordMovementSuccess}
          variant={modalVariant}
        />
      )}
    </>
  )
}
export const CashManageActionBarWithoutButtons: React.FC = () => {
  return (
    <>
      <ActionBar variant="page">{actionBarMessage}</ActionBar>
    </>
  )
}
